import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import { useDeleteUserMutation } from '@/query/user.query';

import type { User } from '@/types/user.type';

type Props = {
  user: User;
  toggle: () => void;
};

export const RemoveUser = ({ user, toggle }: Props) => {
  const deleteUserMutation = useDeleteUserMutation();

  return (
    <AlertDialog open onOpenChange={toggle}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove team member</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to remove{' '}
            <strong className="font-semibold text-foreground">{user?.first_name}</strong> (
            {user?.email}) from the team? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={() => {
              toggle();
              deleteUserMutation.mutate(user.id);
            }}
          >
            Remove member
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
